import React from 'react';
import {
	List,
	Datagrid,
	TextField,
	FunctionField,
} from 'react-admin';
import ConfirmDeleteButton from '../../Components/Button/ConfirmDeleteBtn';

const roleLabels: Record<string, string> = {
	'dev-front': 'Développeur Frontend',
	'dev-back': 'Développeur Backend',
	'po': 'Product Owner',
	'data_analyst': 'Data Analyst',
	'admin': 'Administrateur',
};

export const McpMemberList = (props: any) => (
	<List {...props}>
		<Datagrid rowClick="edit">
			<TextField source="id" label="ID" />
			<TextField source="email" label="Email" />
			<FunctionField
				label="Rôle"
				render={(record: any) => roleLabels[record.role] || record.role}
			/>
			<TextField source="first_name" label="Prénom" />
			<TextField source="last_name" label="Nom" />
			<FunctionField
				label="Statut"
				render={(record: any) => (record.is_active ? 'Actif' : 'Inactif')}
			/>
			<FunctionField
				render={(record: any) => (
					<ConfirmDeleteButton
						record={record}
						title="Supprimer le membre MCP"
						entity="mcp-members"
						description="Êtes-vous sûr de vouloir supprimer ce membre ?"
						confirmMessage="Membre supprimé avec succès"
					/>
				)}
			/>
		</Datagrid>
	</List>
);
